import { useState } from 'react';

export default function useBtnClickImpression() {
  const [btnClass, setBtnClass] = useState('');
  return {
    onMouseUp: () => setBtnClass(''),
    onMouseDown: () => setBtnClass('btnClicked'),
    className: btnClass,
  };
}
